module.exports = __webpack_public_path__ + "img/trinket1.5a60feef.png";